import { Permission } from "App/Modules/Models";
import type { ISiteMenuItem } from "./ISiteMenuItem";
import type { ISiteMenuItemsService } from "./ISiteMenuItemsService";

export class SiteMenuItemsService implements ISiteMenuItemsService {
    public get(): ISiteMenuItem[] {
        return [
            {
                caption: "BeforeLogin.Manage.SideMenu.Overview",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.overview",
            },
            {
                caption: "Entities.Events.Events",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.events",
            },
            {
                caption: "Gui.Manage.SideMenu.DesignAndPlanning",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.designAndPlanning",
            },
            {
                caption: "Gui.Manage.SideMenu.Persons",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.users",
            },
            {
                caption: "Gui.Manage.SideMenu.SystemConfiguration",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.configurationGroups",
            },
            {
                caption: "BeforeLogin.Equipment.Equipments",
                featureSwitcherId: "site-equipment-page",
                permission: { sitePermission: Permission.SiteInformation },
                state: "sites.site.equipment",
            },
            {
                caption: "BeforeLogin.Manage.SideMenu.SystemsTesting",
                permission: { sitePermission: Permission.PartnerOperations },
                state: "sites.site.systemsTesting",
            },
            {
                caption: "Gui.Manage.SideMenu.Activation",
                permission: {
                    sitePermission: Permission.PartnerSettings,
                },
                state: "sites.site.activation",
            },
        ];
    }
}
